/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ViewDynammicFormDetails.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import { DialogActions, IconButton } from "@mui/material";
import ViewDynammicFormDetailsTemplate from "./viewDynamicFormTemplate";
import CloseIcon from "@mui/icons-material/Close";

function ViewDynammicFormDetails({ data, open, handleClose, selectedHeaders }) {

  console.log("View Data", data);

  return (
      <Dialog fullWidth maxWidth={"sm"} onClose={handleClose} open={open}>
        <DialogTitle
          sx={{
            position: "relative", // ✅ allows absolute positioning of close button
            p: 2,
            borderBottom: "none",
          }}
        >
        
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
              position: "absolute", // ✅ detach from flex flow
              right: 2,
              top: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ViewDynammicFormDetailsTemplate data={data} />
        </DialogContent>
        <DialogActions>
          <CustomButtonV2
            type="cancel"
            size="small"
            btnName="Close"
            handleOnClick={handleClose}
          />
        </DialogActions>
      </Dialog>
  );
}


ViewDynammicFormDetails.propTypes = {
  data: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedHeaders: PropTypes.any
};

export default ViewDynammicFormDetails;
